// Third Party
import * as React from "react";
import { PropTypes } from "prop-types";
import cs from "classnames";

// Components
import PillsContainer from "./components/pills-container/pills-container";
import ProductTitle from "./components/product-title/product-title";
import SellingStatementAdapter from "./components/selling-statement/selling-statement.adapter";
import GiftHighlight from "./components/gift-highlight/gift-highlight";

// Hooks
import { useABFlag } from "@lululemon/mwa-ab-testing/esm/components/ABFlags/useABFlag";

function RegularProductDescription({
  abcPantsAbTestFlag,
  abcPantsEducationTest,
  allSkus,
  bestSellerPillComponent,
  createEncodedKey,
  currencyCode,
  currentVariant,
  deviceType,
  displayName,
  dynamicHighlights,
  earlyAccessButtonTracking,
  earlyAccessComponent,
  footwearReturnsPolicyModal,
  highlightType,
  isEarlyAccessEnabled,
  isFinalSale,
  isFootwear,
  locale,
  pdpContentfulData,
  pdpWyltLDFlag,
  MDPromoComponent,
  pills,
  productHighlightComponent,
  reviewsLinkComponent,
  showGiftHighlight,
  showHighlightBestsellerPill,
  styles
}) {
  const pdpReviewRatingABFlag = useABFlag("pdpReviewRating", false);

  const isNotBestSellerOrBestGift =
    !showGiftHighlight && !showHighlightBestsellerPill;
  const shouldShowPillContainerAbove =
    isNotBestSellerOrBestGift && pdpReviewRatingABFlag;
  const shouldShowPillContainerBelow =
    isNotBestSellerOrBestGift && !pdpReviewRatingABFlag;
  const shouldShowBestSeller =
    !showGiftHighlight && showHighlightBestsellerPill;

  const EarlyAccessConnector = earlyAccessComponent;

  return (
    <>
      {shouldShowPillContainerAbove && (
        <PillsContainer
          footwearReturnsPolicyModal={footwearReturnsPolicyModal}
          isEarlyAccessEnabled={isEarlyAccessEnabled}
          pills={pills}
          styles={styles}
        />
      )}
      {showGiftHighlight && (
        <GiftHighlight
          className={styles.pdpGiftBadge}
          highlights={dynamicHighlights || []}
          highlightType={highlightType}
          productHighlightComponent={productHighlightComponent}
        />
      )}
      {shouldShowBestSeller && bestSellerPillComponent}

      <ProductTitle
        className={cs(showHighlightBestsellerPill && styles.titleBottomMargin)}
        createEncodedKey={createEncodedKey}
        title={displayName}
      />
      {isEarlyAccessEnabled && (
        <EarlyAccessConnector
          allSkus={allSkus}
          currencyCode={currencyCode}
          deviceType={deviceType}
          displayName={displayName}
          earlyAccessButtonTracking={earlyAccessButtonTracking}
          productTileImages={productTileImages}
        />
      )}
      <SellingStatementAdapter
        abcPantsAbTestFlag={abcPantsAbTestFlag}
        abcPantsEducationTest={abcPantsEducationTest}
        currentVariant={currentVariant}
        deviceType={deviceType}
        pdpContentfulData={pdpContentfulData}
        pdpWyltLDFlag={pdpWyltLDFlag}
      />
      {pdpReviewRatingABFlag && reviewsLinkComponent}

      {shouldShowPillContainerBelow && (
        <PillsContainer
          footwearReturnsPolicyModal={footwearReturnsPolicyModal}
          isEarlyAccessEnabled={isEarlyAccessEnabled}
          isFootwear={isFootwear}
          locale={locale}
          pills={pills}
          styles={styles}
        />
      )}
      {isFinalSale && MDPromoComponent}
    </>
  );
}

RegularProductDescription.propTypes = {
  abcPantsAbTestFlag: PropTypes.bool,
  abcPantsEducationTest: PropTypes.bool,
  allSkus: PropTypes.arrayOf(PropTypes.shape({})),
  bestSellerPillComponent: PropTypes.node,
  createEncodedKey: PropTypes.func,
  currencyCode: PropTypes.string,
  deviceType: PropTypes.shape({}),
  displayName: PropTypes.string,
  earlyAccessButtonTracking: PropTypes.func,
  earlyAccessComponent: PropTypes.node,
  footwearReturnsPolicyModal: PropTypes.func,
  highlightType: PropTypes.string,
  isEarlyAccessEnabled: PropTypes.bool,
  isFinalSale: PropTypes.bool,
  isFootwear: PropTypes.bool,
  locale: PropTypes.string,
  pdpWyltLDFlag: PropTypes.bool,
  MDPromoComponent: PropTypes.node,
  pills: PropTypes.arrayOf(PropTypes.shape({})),
  productHighlightComponent: PropTypes.node,
  reviewsLinkComponent: PropTypes.node,
  showGiftHighlight: PropTypes.bool,
  showHighlightBestsellerPill: PropTypes.bool,
  styles: PropTypes.shape({})
};

export default RegularProductDescription;
